import React from "react";
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import "jquery";
//dev
import Routes from './routes/public.js';
//css
import '../css/publicApp.css';
import ErrorBoundary from './erorr-boundary/errorHandler';

const App = () => (
	<div>
		<div id="CentionContainer">
			<div id="AdminContainer">
				<Routes />
			</div>
		</div>
	</div>
)
const container = document.getElementById('container');
const root = createRoot(container);

root.render(<ErrorBoundary>
	<HashRouter hashType="noslash">
		<App />
	</HashRouter>
</ErrorBoundary>
);